import { render, staticRenderFns } from "./FOSAgreement.vue?vue&type=template&id=75f5067a&"
import script from "./FOSAgreement.vue?vue&type=script&lang=js&"
export * from "./FOSAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports